import { supabase } from '../lib/supabase';

/**
 * Cria o acesso de aluno/usuário pelo servidor (api/criar-acesso, 16/10/2026):
 * conta já confirmada, perfil gravado e e-mail de boas-vindas da Kzero.
 * Substitui o signUp no navegador, que mandava o e-mail em inglês do Supabase
 * e deixava a conta sem confirmar.
 *
 * Retorna { ok: true, ja_existia, email_enviado } ou { ok: false, erro }.
 */
// Avisa o App para recarregar a lista de usuários (todosUsuarios). Sem isso o
// aluno recém-cadastrado só aparecia na matrícula da turma depois de um F5.
export const EVENTO_USUARIOS_ALTERADOS = 'kz-usuarios-alterados';
export function avisarUsuariosAlterados() {
  window.dispatchEvent(new Event(EVENTO_USUARIOS_ALTERADOS));
}

export async function criarAcessoNoServidor(dados) {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) return { ok: false, erro: 'Sua sessão expirou. Entre de novo para cadastrar.' };
  try {
    const r = await fetch('/api/criar-acesso', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(dados),
    });
    const corpo = await r.json().catch(() => ({}));
    if (!r.ok) return { ok: false, erro: corpo.error || 'Não foi possível criar o acesso.' };
    avisarUsuariosAlterados();
    return { ok: true, ...corpo };
  } catch {
    return { ok: false, erro: 'Não foi possível falar com o servidor. Tente de novo.' };
  }
}
